export class ChangePasswordModel {
  newPassword: string = '';
  confirmPassword: string = '';
}
